import { render, staticRenderFns } from "./companyAuth.vue?vue&type=template&id=f1665674&scoped=true&"
import script from "./companyAuth.vue?vue&type=script&lang=js&"
export * from "./companyAuth.vue?vue&type=script&lang=js&"
import style0 from "./companyAuth.vue?vue&type=style&index=0&id=f1665674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1665674",
  null
  
)

export default component.exports